import type { ClientPanelUser } from 'types'

import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import copy from 'copy.json'
import { clientPanelPaths } from 'paths'

const text = copy.components.clientPanelNavigation

type Props = {
  clientType: ClientPanelUser['type']
}

export default function UserPanelNavigation({ clientType }: Props) {
  return (
    <Wrapper>
      {clientType === 'BUYER' && (
        <>
          <NavLink to={clientPanelPaths.match_data}>{text.match}</NavLink>
          <NavLink to={clientPanelPaths.demand_data}>{text.demand}</NavLink>
        </>
      )}

      {clientType === 'SELLER' && <NavLink to={clientPanelPaths.offer_data}>{text.offer}</NavLink>}

      <NavLink to={clientPanelPaths.personal_data}>{text.client}</NavLink>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  display: flex;
  gap: 32px;
  margin-bottom: -18px;
  border-bottom: 3px solid var(--light-green);

  a {
    font: var(--400-15);
    text-decoration: none;
    color: inherit;
    padding: 9px 0 7px;

    &.active {
      font-weight: 600;
      border-bottom: 5px solid var(--white);
      margin-bottom: -3px;
    }
  }
`
